import apiFetch from '../apiFetch'

export default function (filtros, token) {
  return apiFetch({endPoint: `Informes/getCrearCsvInformesPersonalizado`, method: 'POST', body: filtros, token: token})
}